import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import { TextField } from "@material-ui/core";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import { reduce } from "lodash";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function PersonalInfo() {
  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [player, setPlayer] = useState("");
  const onPlayerChanged = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
      </div>
      <Report
        title="Personal Info Report"
        getUrl={() => "/Reports/Report_Player_Personal_Info_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Player: player,
          Book: book,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          LineType: lineType,
          Group: group,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="email">
          Email
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="address1">
          Address1
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="address2">
          Address2
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="city">
          City
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="state">
          State
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="country">
          Country
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="zip">
          Zip
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phone">
          Phone
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default PersonalInfo;
